import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Leaf, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <div className="flex items-center gap-2.5 mb-6">
          <div className="h-10 w-10 rounded-lg bg-green-700 flex items-center justify-center">
            <Leaf className="h-5 w-5 text-white" />
          </div>
          <div className="font-heading font-bold text-slate-900">SIA-HPP GREENCON</div>
        </div>
        {sent ? (
          <div className="text-center py-4">
            <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto" />
            <h1 className="font-heading text-xl font-bold text-slate-900 mt-4">Tautan Terkirim</h1>
            <p className="text-sm text-slate-500 mt-2">
              Jika email terdaftar, tautan reset password telah dikirim. Periksa konsol server untuk tautan reset (mode demo).
            </p>
            <Link to="/login"><Button variant="outline" className="mt-6">Kembali ke Login</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Lupa Password</h1>
            <p className="text-sm text-slate-500 mt-1">Masukkan email Anda untuk menerima tautan reset.</p>
            {error && <p className="text-sm text-red-600 mt-4">{error}</p>}
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold text-slate-600">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9" data-testid="forgot-email-input" />
                </div>
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-green-700 hover:bg-green-800" data-testid="forgot-submit-btn">
                {loading ? "Mengirim..." : "Kirim Tautan Reset"}
              </Button>
            </form>
            <Link to="/login" className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mt-6">
              <ArrowLeft className="h-4 w-4" /> Kembali ke Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
